import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'
import Everett from '../../components/Everett/Everett'

const Everettpage = () => {
    return (
        <div>
        <Navbar/>
        <Everett/>



        <Footer/>

        </div>
    )
}

export default Everettpage